import InspectorAssignPage from "./pages/InspectorAssignPage";
import "./styles/inspectorAssign.scss";

export default function InspectorAssign() {
  return <InspectorAssignPage />;
}
